import apiRequest from './apiRequest';

type ResponsePayload = {
  playbackSettings: {
    trimFrameStart?: number;
    trimFrameEnd?: number;
  };
};

export default async function postMotionSettings(
  jobID: string,
  animationNumber: number,
  trimFrameStart: number,
  trimFrameEnd: number,
) {
  return await apiRequest<ResponsePayload>(
    'mogen-orchestration',
    `/jobs/${jobID}/trim?animationNumber=${animationNumber}`,
    {
      method: 'POST',
      body: JSON.stringify({
        playbackSettings: {
          trimFrameStart,
          trimFrameEnd,
        },
      }),
    },
  );
}
